<script setup>
import ReferenceLink from '@/components/shared/ReferenceLink.vue'
import { menuRoutesEnum, getDocumentRouteByDocumentType } from '@/router'

defineProps({
  cellInfo: {
    type: Object,
    required: true
  }
})
</script>

<template>
  <div style="display: flex; flex-wrap: wrap; gap: 0.25rem;">
    <reference-link
      v-if="cellInfo.data.quote?.series && cellInfo.data.quote?.number_mnemonic"
      :data="{ series: cellInfo.data.quote.series, number: cellInfo.data.quote.number_mnemonic }"
      :text-fields="['prefix', 'series', 'number']"
      :query-fields="['series', 'number']"
      :target="menuRoutesEnum.QUOTES"
    />

    <reference-link
      v-if="cellInfo.data.worksheet?.series && cellInfo.data.worksheet?.number_mnemonic"
      :data="{ series: cellInfo.data.worksheet.series, number: cellInfo.data.worksheet.number_mnemonic }"
      :text-fields="['prefix', 'series', 'number']"
      :query-fields="['series', 'number']"
      :target="menuRoutesEnum.WORKSHEETS"
    />

    <reference-link
      v-if="cellInfo.data.saledocument?.series && cellInfo.data.saledocument?.number_mnemonic"
      :data="{ series: cellInfo.data.saledocument.series, number: cellInfo.data.saledocument.number_mnemonic }"
      :text-fields="['prefix', 'series', 'number']"
      :query-fields="['series', 'number']"
      :target="getDocumentRouteByDocumentType(cellInfo.data.saledocument.type)"
    />

    <reference-link
      v-if="cellInfo.data.supplierorder?.series && cellInfo.data.supplierorder?.number_mnemonic"
      :data="{ series: cellInfo.data.supplierorder.series, number: cellInfo.data.supplierorder.number_mnemonic }"
      :text-fields="['prefix', 'series', 'number']"
      :query-fields="['series', 'number']"
      :target="menuRoutesEnum.SUPPLIER_ORDERS"
    />

    <reference-link
      v-if="cellInfo.data.subject?.subject_ref"
      :data="{ id: cellInfo.data.subject.subject_ref, code: cellInfo.data.subject.subject_code }"
      :text="`${cellInfo.data.subject.subject_code} - ${cellInfo.data.subject.subject_name} ${cellInfo.data.subject.subject_name_ext}`"
      :query-fields="['id', 'code']"
      :target="menuRoutesEnum.SUBJECTS"
    />

    <reference-link
      v-if="cellInfo.data.vehicle?.vehicle_code"
      :data="{ code: cellInfo.data.vehicle.vehicle_code }"
      :text="`${cellInfo.data.vehicle.vehicle_code} - ${cellInfo.data.vehicle.vehicle_name}`"
      :query-fields="['code']"
      :target="menuRoutesEnum.VEHICLES"
    />
  </div>
</template>
